import { Pipe, PipeTransform } from '@angular/core';

import { ComboboxOption } from '@sui/combobox';

/**
 * Maps the dynamic-form `select` item shape (`{ name, value }`) to sui-combobox's
 * `{ label, value }` options. Pure: re-maps only when the input array reference
 * (or `groupByKey`) changes, so the combobox isn't rebuilt every change-detection
 * cycle.
 *
 * `groupByKey`: when supplied, each item's value
 * at that key is carried onto `option.group`, and sui-combobox renders grouped
 * under headers. Omitted ⇒ flat list (the common case).
 */
@Pipe({
  name: 'comboboxOptions',
  standalone: false,
})
export class ComboboxOptionsPipe implements PipeTransform {
  transform(
    items:
      | Array<{ name: string; value: unknown; disabled?: boolean }>
      | null
      | undefined,
    groupByKey?: string,
  ): ComboboxOption[] {
    if (!items) return [];
    return items.map((it) => ({
      label: it.name,
      value: it.value,
      disabled: it.disabled,
      group: groupByKey
        ? ((it as Record<string, unknown>)[groupByKey] as string)
        : undefined,
    }));
  }
}
